const images = [
  '/solutions/dsa/integration.png',
  '/solutions/dsa/fees.png',
  '/solutions/dsa/pymts.png',
  '/solutions/dsa/reporting.png',
  '/solutions/dsa/migration.png',
  '/solutions/dsa/inv_widget_dark.png',
  '/solutions/dsa/pymt_widget_dark.png',
];

export default images;
